import { render, staticRenderFns } from "./registration-by-email-confirmation.vue?vue&type=template&id=cb252cf0"
import script from "./registration-by-email-confirmation.vue?vue&type=script&lang=js"
export * from "./registration-by-email-confirmation.vue?vue&type=script&lang=js"
import style0 from "./registration-by-email-confirmation.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/quick-login-reg/registration-by-email-confirmation.vue
// module id = Uv/l
// module chunks = 0